module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isSupportedGrade && !_vm.isParentUser) ? _c('div', {
    staticClass: "proficiency-container"
  }, [_c('div', {
    staticClass: "not-support-grade"
  }, [_c('div', {
    staticClass: "title px-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.user_proficiency')) + "\n        "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.previewProficiencyModal",
      modifiers: {
        "previewProficiencyModal": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-title px-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))])])])]) : [(!_vm.isParentUser) ? _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.user_proficiency',
      "eventLabel": 'levels.view_more',
      "routeName": 'cat-proficiency'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "proficiency-container"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.filterSubjects,
      "selectedId": _vm.selectedSubjectId
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('CatScore', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubjectId,
      "selectedSubjectColor": _vm.selectedSubjectColor
    }
  }), _vm._v(" "), _c('CatRank', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubjectId
    }
  })], 1), _vm._v(" "), _c('CatRankPolicy')], 1)], _vm._v(" "), _c('b-modal', {
    ref: "modal",
    staticClass: "preview-proficiency-modal",
    attrs: {
      "id": "previewProficiencyModal",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "preview-proficiency"
  }, [_c('div', {
    staticClass: "preview-proficiency-header"
  }, [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))]), _vm._v(" "), _c('div', {
    staticClass: "preview-proficiency-body"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_sample_level.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-proficiency-footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseClick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.confirmation')) + "\n          ")])])])])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7038d564","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatProficiency.vue
// module id = 1590
// module chunks = 1